<!-- Blocks Calculater -->
<div class="bg-card-new card-radius-06 quantity-calculator">
    <div class="title-box">
        <div>{{"calculate_tiles_text"|translate}}</div>
    </div>
    <div class="p-4 flex flex-col">
        <div class="flex flex-col gap-1">

            <div *ngFor="let areaForm of formsList; let i = index;" class="flex flex-col" [formGroup]="areaForm">
                <div class="mb-1 area">Wall Area {{i+1}}</div>
                <div class="flex flex-row gap-4">
                    <div class="form-group">
                        <label class="control-label">{{"width_metter"|translate}}</label>
                        <input type="text" class="form-control form-control-rounded" formControlName="width">
                    </div>

                    <div class="form-group">
                        <label class="control-label">{{"length_metter"|translate}}</label>
                        <input type="text" class="form-control form-control-rounded" formControlName="length">
                    </div>

                    <button *ngIf="formsList.length>1" t ype="button" class="btn btn-secondary remove-btn" (click)="removeArea()">X</button>
                </div>
            </div>
        </div>
        <div class="flex flex-row gap-4 mt-3">
            <button type="button" class="btn btn-primary btn-calculate" (click)="getAreaPrice()">{{"calculate"|translate}}</button>
            <button type="button" class="btn btn-primary btn-add" style="width: 100%" (click)="addArea()">{{"+  Add Area"}}</button>
        </div>
        <div style="border: 0; padding: 5px; margin-top: 8px">
            <div class='flex-auto'>
                <div>
                    <table class="calc-table" style="table-layout: fixed;">
                        <thead>
                            <tr>
                                <th style="padding-right: 15px;">{{"quantity_needed"|translate}}</th>
                                <th>{{"price"|translate}}</th>
                            </tr>
                        </thead>
                        <tbody class="">
                            <tr>
                                <td>{{tCount}} </td>
                                <td>{{ tPrice|currencyConvert : currencyCode }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="flex flex-row">
                <div class="form-check">
                    <span class="form-check-input input-check">
                        <span class="input-check__body">
                            <input class="input-check__input" type="checkbox" name="extra" id="extra" value="additional-coverage" checked="" (click)="getAreaPrice()" />
                            <span class="input-check__box rounded-full"></span>
                            <app-icon class="input-check__icon" name="selectChecked" size="9x7"></app-icon>
                        </span>
                    </span>
                    <label class="form-check-label" for="extra">Add 10% in case of damage</label>
                </div>
            </div>
        </div>
        <div>
            <small class="note">{{"calulcate_tiles_note"|translate}}</small>
        </div>
    </div>
</div>
